<template>
    <div class="kanban-page">
        <div class="header-logo">
            <img src="/img/kanban/title.png" class="store-logo">
        </div>
        <div class="kanban-contanier">
            <div class="kanban-con">
                <div class="left-container">
                    <div class="first-box">
                        <div class="title">广告实时投放</div>
                        <div class="first-content">
                            <words-roll :list="adList"></words-roll>
                        </div>
                    </div>
                    <div class="second-box">
                        <div class="title">近7天LED大屏幕状态</div>
                        <div class="second-content">
                            <double-bar-charts
                                :list="bigScreenList"
                                :legendData="[{name:'总终端数', type:'bigTotal'}, {name:'当日在线终端数', type:'bigOnlineTotal'}]">
                            </double-bar-charts>
                        </div>
                    </div>
                    <div class="third-box">
                        <div class="title">每日刊播汇总统计</div>
                        <div class="third-content">
                            <double-bar-charts
                                :list="everydayList"
                                :legendData="[{name:'播放次数', type:'playCount'}, {name:'设备数量', type:'deviceCount'}]"
                                :doubleY="true">
                            </double-bar-charts>
                        </div>
                    </div>
                </div>

                <div class="middle-container">
                    <div class="china-map-content">
                        <div class="data-content">
                            <div class="first-data data-box">
                                <div class="data-wrap">{{detailData.cityCount}}</div>
                                <div class="title">城市总数</div>
                            </div>
                            <div class="second-data data-box">
                                <div class="data-wrap">{{detailData.storeCount}}</div>
                                <div class="title">商场数</div>
                            </div>
                            <div class="third-data data-box">
                                <div class="data-wrap">{{detailData.deviceCount}}</div>
                                <div class="title">屏幕数</div>
                            </div>
                            <div class="fourth-data data-box">
                                <div class="data-wrap">{{detailData.coveredPopulation}}</div>
                                <div class="title">覆盖人群</div>
                            </div>
                        </div>
                        <china-map :list="mapAreaList"></china-map>
                    </div>
                    <div class="ad-sk-content">
                        <div class="title">广告上刊趋势</div>
                        <div class="sk-wrap">
                            <line-charts :list="skList" style="min-height: 8vh;"></line-charts>
                        </div>
                    </div>
                </div>

                <div class="right-container">
                    <div class="first-box">
                        <div class="title">屏幕分布</div>
                        <div class="first-content">
                            <circle-charts :list="screenList"></circle-charts>
                        </div>
                    </div>
                    <div class="second-box">
                        <div class="title">近7天LED小屏幕状态</div>
                        <div class="second-content">
                            <double-bar-charts
                                :list="bigScreenList"
                                :legendData="[{name:'总终端数', type:'smallTotal'}, {name:'当日在线终端数', type:'smallOnlineTotal'}]">
                            </double-bar-charts>
                        </div>
                    </div>
                    <div class="third-box">
                        <div class="title">商场年度广告上刊排行</div>
                        <div class="third-content">
                            <div class="sk-rank-title">
                                <div class="rank-name">TOP</div>
                                <div class="rank-name">商场</div>
                                <div class="rank-name">上刊量</div>
                            </div>
                            <div class="sk-rank-body">
                                <div :class="['sk-rank-item',index==0?'first':index==1?'second':index==2?'third':'']" v-for="(item, index) in yearRankList" :key="index">
                                    <div class="order sk-item-box">NO.{{(index + 1).toString().padStart(2, '0')}}</div>
                                    <div class="market-name sk-item-box">{{item.storeName}}</div>
                                    <div class="sk-num sk-item-box">{{item.totalCount}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="foot-title">新潮百新智联科技有限公司   技术支持</div>
    </div>
</template>

<script>
// 自适应
import '@/utils/rem';

import wordsRoll from "../components/kanban/WordsRoll.vue";
import CircleCharts from "../components/kanban/CircleCharts.vue";
import DoubleBarCharts from "../components/kanban/DoubleBarCharts.vue";
import ChinaMap from "../components/kanban/ChinaMap.vue";
import LineCharts from "../components/kanban/LineCharts.vue";
export default {
    name: "Kanban",
    components: {
        wordsRoll,
        CircleCharts,
        DoubleBarCharts,
        ChinaMap,
        LineCharts
    },
    data(){
        return {
            // 广告实时投发列表
            adList: [],
            // 屏幕分布列表
            screenList: [],
            // LED 大屏状态
            bigScreenList: [],
            // 每日汇总数据列表
            everydayList: [],
            // 地图相关的数据
            mapAreaList: [],
            // 主要详情数据展示
            detailData: {},
            // 上刊趋势列表
            skList: [],
            // 年度上刊排行
            yearRankList: []
        }
    },
    mounted(){
        this.initial()
;    },
    methods: {
        // 数据初始化
        initial(){
            // 广告实时投发
            this.$http.get("/data/board/program/realtime").then(res => {
                this.adList = res.data;
            });
            // LED屏幕状态（大屏和小屏在一起）
            this.$http.get("/data/board/led/status").then(res => {
                this.bigScreenList = res.data;
            });
            // 每日刊播汇总统计
            this.$http.get("/data/board/monitor").then(res => {
                this.everydayList = res.data;
            });
            // 主要的统计的数据
            this.$http.get("/data/board/main/static").then(res => {
                this.detailData = res.data;
            })
            // 地图区域展示
            this.$http.get("/data/board/province/map").then(res => {
                this.mapAreaList = res.data;
            });
            // 广告上刊趋势数据
            this.$http.get("/data/board/program/count").then(res => {
                this.skList = res.data;
            });
            // 屏幕分布
            this.$http.get("/data/board/screen/size").then(res => {
                this.screenList = res.data.map(item => {
                    return {
                        name: item.screenSize,
                        value: item.deviceNum
                    }
                })
            });
            // 年度广告上刊排行
            this.$http.get("/data/board/store/program").then(res => {
                this.yearRankList = res.data.slice(0, 10);
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.kanban-page{
    position: relative;
    display: flex;
    width: 100%;
    height: 100vh;
    padding: 25px 19px 14px;
    background: url("/img/kanban/big-bg.png") center center no-repeat;
    .header-logo{
        display: flex;
        justify-content: center;
        position: absolute;
        left: 0px;
        right:0px;
        top: 9px;
        margin: auto;
        .store-logo{
            width: 588px;
            height: auto;
        }
    }
    .foot-title{
        display: flex;
        justify-content: center;
        position: absolute;
        left: 0px;
        right:0px;
        bottom: 27px;
        margin: auto;
        line-height: 14px;
        font-family: SourceHanSansCN-Regular;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: rgba(22, 230, 229, 0.3);
    }
    .kanban-contanier{
        display: flex;
        flex:1;
        background-image: url("/img/kanban/mid-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        .kanban-con{
            display: flex;
            flex:1;
            padding: 44px 42px 40px;
        }
    }
}

// 内容区中的公共样式
.left-container, .right-container{
    display: flex;
    width: 420px;
    height: 100%;
    flex-direction: column;
    .first-box, .second-box, .third-box{
        display: flex;
        flex-direction: column;
        width: 100%;
        background-repeat: no-repeat;
        background-size: 100% 102%;
        background-position: 0px -6px;
        margin-bottom: 20px;
    }
    .first-box{
        height: 292px;
        background-image: url("/img/kanban/first.png");
    }
    .second-box{
        height: 238px;
        background-image: url("/img/kanban/second.png");
    }
    .third-box{
        flex:1;
        background-image: url("/img/kanban/third.png");
        background-size: 100% 101%;
        background-position: 0px -6px;
        margin-bottom: 0px;
    }

    // 内容区
    .first-content{
        flex: 1;
        padding: 12px 20px 20px;
        overflow: hidden;
    }
    .second-content, .third-content{
        flex:1;
        overflow: hidden;
    }
}

.title{
    padding: 11px 0px 4px 20px;
    line-height: 22px;
    font-family: PingFangSC-Semibold;
	font-size: 22px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #16e6e5;
}

// 左边相关的样式
.left-container{

}

// 中间相关样式
.middle-container{
    flex:1;
    display: flex;
    flex-flow: column;
    padding: 0px 18px;
    .china-map-content{
        position: relative;
        height: 71vh;
        margin-bottom: 20px;
        background-image: url("/img/kanban/map-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100.5%;
        background-position: 0px -5px;
        .data-content{
            display: flex;
            align-items: center;
            position: absolute;
            top: 22px;
            height: 96px;
            width: 100%;
            padding: 0px 28px;
            z-index: 99;
            .data-box{
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100%;
                background-repeat: no-repeat;
                background-size: 100% 101.5%;
                background-position: 0px -2px;
                .data-wrap{
                    line-height: 50px;
                    font-family: DINAlternate-Bold;
                    font-size: 50px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 2px;
                    color: #ffffff;
                }
                .title{
                    margin-top: 8px;
                    padding: 0px;
                    line-height: 16px;
                    font-family: MicrosoftYaHei;
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    color: #ffffff;
                }
                &:not(:last-child){
                    margin-right: 15px;
                }
            }
            .first-data{
                width:180px;
                background-image: url("/img/kanban/1.png");
            }
            .second-data{
                width:180px;
                background-image: url("/img/kanban/2.png");
            }
            .third-data{
                width:210px;
                background-image: url("/img/kanban/3.png");
            }
            .fourth-data{
                flex:1;
                background-image: url("/img/kanban/4.png");
            }
        }
    }
    .ad-sk-content{
        display: flex;
        flex-direction: column;
        flex:1;
        background-image: url("/img/kanban/sk-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 102%;
        background-position: 0px -6px;
        .sk-wrap{
            flex:1;
        }
    }
}

// 右边相关样式
.right-container{
    .third-content{
        display: flex;
        flex-direction: column;
        padding: 15px 28px 28px;
        overflow: hidden;
        .sk-rank-title{
            display: flex;
            align-items: center;
            width: 100%;
            .rank-name{
                width: 20%;
                line-height: 14px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #f4a695;
                text-align: center;
                &:nth-child(2){
                    width: 60%;
                }
            }
        }
        .sk-rank-body{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding-top: 15px;
            flex:1;
            overflow: hidden;
            .sk-rank-item{
                display: flex;
                align-items: center;
                color: #a9adbb;
                .sk-item-box{
                    width: 20%;
                    line-height: 14px;
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    text-align: center;
                    letter-spacing: 0.5px;
                    font-family: DINAlternate-Bold;
                    &:nth-child(2){
                        width: 60%;
                        letter-spacing: 1px;
                        font-family: PingFangSC-Regular;
                    }
                }
                &.first{
                    color: #fec519;
                }
                &.second{
                    color: #bbd2d7;
                }
                &.third{
                    color: #e2c8a9;
                }
            }
        }
    }
}
</style>